import { gql } from '@apollo/client';

export default gql`
  fragment permissionsFragment on Permissions {
    ADMIN_CREATE_PAYMENTS
    ADMIN_DELETE_PAYMENTS
    ADMIN_READ_PAYMENTS
    ADMIN_RETRY_PAYMENTS
    ADMIN_REFUND_PAYMENTS
    ADMIN_UPDATE_PAYMENTS
    ADMIN_UPDATE_THRESHOLD
    APPLY_PROMO_CODE
    BUILD_REPORT
    CANCEL_LINE_ITEM
    CLONE_LINE_ITEM
    CONFIGURE_AD_TAG
    CREATE_AD_ACCOUNT
    CREATE_ASSET
    CREATE_BRAND
    CREATE_BROADCAST
    CREATE_CAMPAIGN
    CREATE_CREATIVE
    CREATE_KERV_CREATIVE
    UPDATE_KERV_CREATIVE
    CREATE_INDUSTRY
    CREATE_LINEITEM
    CREATE_PAYMENTS
    CREATE_REPORT
    CREATE_USER
    DELETE_AD_ACCOUNT
    DELETE_BROADCAST
    DELETE_CAMPAIGN
    DELETE_CREATIVE
    DELETE_CREATIVES
    DELETE_LINE_ITEM
    DELETE_ORGANIZATION
    DELETE_PAYMENTS
    DELETE_REPORT
    DETACH_PROMO_CODE
    GET_CAMPAIGN
    GET_LINE_ITEM
    INVITE_USER
    PAUSE_LINE_ITEM
    READ_AD_ACCOUNT
    READ_ALL_ADS
    READ_ALL_CAMPAIGNS
    READ_ALL_LINE_ITEMS
    READ_BRAND
    READ_BROADCAST
    READ_CAMPAIGN_LINEITEMS
    READ_CREATIVE
    READ_CREATIVES
    READ_INDUSTRY
    READ_LEGACY_REPORT
    READ_NOTIFICATION
    READ_ORGANIZATION
    READ_OWN_USER
    READ_PAYMENTS
    READ_REPORT
    READ_REPORT_TEMPLATE
    READ_ROLES
    READ_TARGETING
    READ_USER
    READ_USERS
    RESUME_LINE_ITEM
    SUBMIT_LINE_ITEM
    SUSPEND_LINE_ITEM
    UPDATE_AD_ACCOUNT
    UPDATE_AD_ACCOUNT_BILLING_CONTACT
    UPDATE_AD_ACCOUNT_BRAND
    UPDATE_AD_ACCOUNT_NAME
    UPDATE_BRAND
    UPDATE_BROADCAST
    UPDATE_CAMPAIGN
    UPDATE_INDUSTRY
    UPDATE_LINE_ITEM
    UPDATE_NOTIFICATION_SETTINGS
    UPDATE_ORGANIZATION
    UPDATE_PAYMENTS
    UPDATE_REPORT
    UPDATE_USER
    USER_STATUS_UPDATE
    OVERRIDE_LINE_ITEM_PRICE
  }
`;
